export default "__VITE_ASSET__C7Qf0t26__"